module.exports = __webpack_public_path__ + "img/cross-round.6d7c264c.svg";